import React from 'react'
import CollapsibleFilter from '../CollapsibleFilter/CollapsibleFilter'
import CollapsibleDateFilter from '../CollapsibleDateFilter/CollapsibleDateFilter';
import { FILTERS } from '../../../../data/filters';

import styles from './Filters.module.scss';

type FiltersType = {
    isDropdown?: boolean;
}

export default function Filters({
    isDropdown
}: FiltersType) {
    return (
        <div className={isDropdown ? styles.Dropdown : undefined} style={{height: '100%'}}>
            {!isDropdown && (<h3 style={{ marginBottom: '1rem' }}>Filters</h3>)}
            <div className={styles.filtersWrapper}>
                <CollapsibleDateFilter></CollapsibleDateFilter>
                {FILTERS.map((fil, index) => (
                    <CollapsibleFilter key={index} category={fil.category} categoryValues={fil.filterValues}></CollapsibleFilter>))}
            </div>
        </div>
    )
}
